export const tenantIds = {
  ATCOM: 'atcom',
}
